{
    "target": {
        "od550aer": {
            "beta": 2.0
        },
        "concno2": {
            "beta": 2.0
        },
        "conco3": {
            "beta": 2.0
        },
        "conco3mda8": {
            "beta": 2.0
        },
        "concpm10": {
            "beta": 2.0
        },
        "concpm25": {
            "beta": 2.0
        }
    },
    "bars": {
        "observations": {
            "title": "Obs",
            "charts": {
                "obs-mean": {
                    "title": "Mean",
                    "statistic": "MPI_mean",
                    "range": [
                        0,
                        100
                    ],
                    "bands": [],
                    "target-dot": false
                },
                "obs-exceedances": {
                    "title": "Exc.",
                    "statistic": "exceedances_obs",
                    "range": [
                        0,
                        100
                    ],
                    "bands": [],
                    "target-dot": false,
                    "disabled": false
                }
            },
            "exceedances": {
                "conco3": 120,
                "conco3mda8": 120,
                "concno2": 200,
                "concpm10": 50,
                "concpm25": 25
            }
        },
        "time": {
            "title": "Time",
            "charts": {
                "time-bias": {
                    "title": "Bias",
                    "statistic": "MPI_bias_t",
                    "range": [
                        -2,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -1,
                                1
                            ]
                        },
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -0.75,
                                0.75
                            ]
                        }
                    ]
                },
                "time-r": {
                    "title": "1−R",
                    "statistic": "MPI_R_t",
                    "range": [
                        0,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                0,
                                1
                            ]
                        },
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                0,
                                0.5
                            ]
                        }
                    ]
                },
                "time-stdv": {
                    "title": "Stdev",
                    "statistic": "MPI_std_t",
                    "range": [
                        -2,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -1,
                                1
                            ]
                        },
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -0.75,
                                0.75
                            ]
                        }
                    ]
                },
                "hperc": {
                    "title": "Hperc",
                    "statistic": "MPI_Hperc",
                    "range": [
                        -2,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -1,
                                1
                            ]
                        }
                    ],
                    "disabled": false
                }
            }
        },
        "space": {
            "title": "Space",
            "charts": {
                "space-r": {
                    "title": "1−R",
                    "statistic": "MPI_R_s",
                    "range": [
                        0,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                0,
                                1
                            ]
                        },
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                0,
                                0.5
                            ]
                        }
                    ]
                },
                "space-stdv": {
                    "title": "Stdev",
                    "statistic": "MPI_std_s",
                    "range": [
                        -2,
                        2
                    ],
                    "bands": [
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -1,
                                1
                            ]
                        },
                        {
                            "color": "rgba(125, 125, 125, 0.05)",
                            "range": [
                                -0.75,
                                0.75
                            ]
                        }
                    ]
                }
            }
        }
    }
}